import Style from "@assets/css/workshope.module.css";
import { handleClassNames } from "lib/cssHelpers";

import Skeleton from "react-loading-skeleton";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Modal } from "react-bootstrap";
import React, { useState, useCallback, useEffect } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
  LoadScript,
} from "@react-google-maps/api";
import { isMobile } from "react-device-detect";
import { OffCanvas, OffCanvasMenu, OffCanvasBody } from "react-offcanvas";
import useWindowDimensions from "components/WindowSize";
import Select from "react-select";
// import WorkshopTime from "../common/WorkshopTime";
import moment from "moment";
import { setLocation } from "../../redux/actions/profileAction";
import { connect } from "react-redux";
// import WorkshopModal from "./WorkshopModal";
import OutsideClickHandler from "react-outside-click-handler";
import {
  fetchDefaultWorkshop,
  getModel,
  getWorkshopsJourneyVariant,
  getWorkshopsProductCategory,
} from "../../redux/actions/apiActions";
import { FaInfoCircle, FaTimes } from "react-icons/fa";
import { toast } from "react-hot-toast";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { usePlacesWidget } from "react-google-autocomplete";
import Image from "next/image";
import WorkshopModal from "components/HeroSlider/WorkshopModal";
import { route } from "next/dist/server/router";
import { useRouter } from "next/router";
import { useRef } from "react";
import { Autocomplete as MyCustomAutocomplete } from "react-google-autocomplete";
import { setLoader } from "redux/actions/globalAction";
import { GetInfo } from "lib/Location";
import { setCartStage, setCartWorkshop } from "redux/actions/cartAction";
import { ThreeDots } from "react-loader-spinner";
import MapComponent from "../common/map";
const hasWindow = typeof window !== "undefined";
const widthS = hasWindow ? window.innerWidth : "650px";

const MapView = ({
  apiData,
  globalData,
  getLocationData,
  getWorkshopsJourneyCategory,
  getCoordinates,
  coordinatesData,
  amenitiesData,
  workshopJourneyCategoryData,
  getWorkshopAmenities,
  setLocation,
  fetchDefaultWorkshop,
  placeChanged,
  hadLocation,
  setLoader,
  setCartStage,
  cart,
  getWorkshopsProductCategory,
}) => {
  const divRef = useRef(null);
  const containerStyle = {
    width: isMobile
      ? divRef?.current?.clientWidth
      : divRef?.current?.clientWidth - 30,
    height: "620px",
  };
  const { height, width } = useWindowDimensions();
  const autocompleteRef = useRef(null);
  const { ref } = usePlacesWidget({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
    onPlaceSelected: (place) => {
      setDropDownSelection(true);
      setLocationText(place.formatted_address);
      onPlaceChangedNew(
        place.geometry.location.lat(),
        place.geometry.location.lng(),
        place.formatted_address
      );
    },
    options: {
      types: [],
      componentRestrictions: { country: "AE" },
    },
  });
  const [map, setMap] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [hideBar, setHideBar] = useState(true);
  const [sLoaded, setSLoaded] = useState(false);
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  const [latTemp, setLatTemp] = useState(0);
  const [longTemp, setLongTemp] = useState(0);
  const [latMap, setLatMap] = useState(0);
  const [longMap, setLongMap] = useState(0);
  const [zoom, setZoom] = useState(11);
  const [autocompleted, setAutocompleted] = useState();
  const [workShop, setWorkShop] = useState([]);
  const [hide, setHide] = useState(false);
  const [sos, setSos] = useState(false);
  const [sosMobile, setSosMobile] = useState(false);
  const [mapSos, setMapSos] = useState(false);
  const [days, setDays] = useState([]);
  const [locationText, setLocationText] = useState("");
  const [checkCenter, setCheckCenter] = useState(false);
  const [showError, setShowError] = useState(false);
  const [address, setAddress] = useState("");
  const [activeLocationChange, setActiveLocationChange] = useState(true);
  const [showMap, setShowMap] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [search, setSearch] = useState("");
  const [dropDownSelection, setDropDownSelection] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [mapLoading, setMapLoading] = useState(true);
  const carNameParam = "car";

  const handleClasses = (classValue) => {
    return handleClassNames(classValue, Style);
  };
  const mapViewRef = useRef(null);

  useEffect(() => {
    setMapLoading(true);
    if (mapViewRef.current) {
      const loadingDiv = mapViewRef.current.querySelector("div:nth-child(2)");
      if (loadingDiv && loadingDiv.textContent.includes("Loading...")) {
        setMapLoading(true);
        setTimeout(() => {
          setMapLoading(false);
        }, 5000);
      } else {
        setMapLoading(false);
      }
    }
  }, [mapViewRef, mapLoading]);

  const router = useRouter();

  // useEffect(() => {
  //   setTimeout(() => {
  //     setMapLoading(false);
  //   }, 3000);
  // }, []);

  useEffect(() => {
    fetchDefaultWorkshop();
    // if (!globalData.locationData.data) {
    // Test Area
    if (!hadLocation) {
      getCurrentLocation(true);
    } else {
      const latCurrent = Number(hadLocation.lat);
      const langCurrent = Number(hadLocation.lang);
      onPlaceChangedNew(latCurrent, langCurrent);
      // setLat(Number(latCurrent));
      // setLong(Number(langCurrent));
      // getCoordinates(latCurrent, langCurrent, 10);
      // setLatMap(latCurrent);
      // setLongMap(langCurrent);
      setCheckCenter(false);
    }
  }, []);

  const handleVisitStoreFront = (item) => {
    setLoader(true);
    router.push(`/workshop/${item?.Slug}`);
  };

  useEffect(() => {
    if (globalData.locationData?.data) {
      if (activeLocationChange) {
        setLocationText(globalData.locationData.data.EmirateArea);
      } else {
        setActiveLocationChange(true);
      }
    }
  }, [globalData.locationData?.data]);

  useEffect(() => {
    if (placeChanged) {
      onPlaceSelected();
    }
  }, [placeChanged]);

  useEffect(() => {
  
    if (coordinatesData?.length > 0) {
      if (coordinatesData[0].Distance < 50) {
        setZoom(11);
      } else if (
        coordinatesData[0].Distance > 50 &&
        coordinatesData[0].Distance < 89
      ) {
        setZoom(10);
      } else if (
        coordinatesData[0].Distance > 90 &&
        coordinatesData[0].Distance < 139
      ) {
        setZoom(9);
      } else if (coordinatesData[0].Distance > 140) {
        setZoom(8);
      }
    }
  }, [coordinatesData]);

  const getCurrentLocation = (isFirst = false) => {
    locateCurrentPosition()
      .then((position) => {
        const lat = Number(position.coords.latitude);
        const lang = Number(position.coords.longitude);
        setLat(Number(lat));
        setLong(Number(lang));
        if (isFirst && hadLocation) {
          const latCurrent = Number(hadLocation.lat);
          const langCurrent = Number(hadLocation.lang);
          getCoordinates(latCurrent, langCurrent, 10);
          setLatMap(latCurrent);
          setLongMap(langCurrent);
          setCheckCenter(false);
        } else {
          setLatTemp(Number(lat));
          setLongTemp(Number(lang));
          setLatMap(Number(lat));
          setLongMap(Number(lang));
        }

        onPlaceChangedNew(lat, lang);
      })
      .catch((e) => {
        // toast.error("Location not allowed")
        setShowError(true);
        setTimeout(() => {
          setShowError(false);
        }, 7000);
        GetInfo(getinfoCallback, getinfoErrorCallback);
      });
  };

  const onPlaceSelected = (place) => {
    //   setDropDownSelection(true)
    setLocationText(place.formatted_address);
    onPlaceChangedNew(
      place.geometry.location.lat(),
      place.geometry.location.lng(),
      place.formatted_address
    );
  };

  const locateCurrentPosition = () =>
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve(position);
        },
        (error) => {
          console.log(error.message);
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 1000,
        }
      );
    });

  const getinfoCallback = (lat, lang) => {
    setLat(Number(lat));
    setLong(Number(lang));
    setLatTemp(Number(lat));
    setLongTemp(Number(lang));
    setLatMap(Number(lat));
    setLongMap(Number(lang));
    onPlaceChangedNew(lat, lang);
  };

  const getinfoErrorCallback = (lat, lng) => {
    setLoaded(false);
  };

  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds({ lat: lat, lng: long });
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  const onLoads = (marker) => {
    console.log("marker: ", marker);
  };

  const scriptLoad = () => {
    // window.gm_authFailure = () => {
    //   console.error('Failed to load Google Maps API -----------------');
    // };
    setSLoaded(true);
  };

  const onLoading = (autocomplete) => {
    setAutocompleted(autocomplete);
  };

  const onPlaceChanged = () => {
    if (autocompleted !== null) {
      try {
        setSkeletonLoading(true);
        setTimeout(() => {
          setSkeletonLoading(false);
        }, 2000);
        const lat = Number(autocompleted.getPlace()?.geometry?.location.lat());
        const lang = Number(autocompleted.getPlace()?.geometry?.location.lng());
        onPlaceChangedNew(lat, lang);
      } catch (error) {
        console.log(error);
        getCurrentLocation();
      }
    } else {
    }
  };

  const onPlaceChangedNew = async (lats, longs) => {
    try {
      const lat = Number(lats);
      const lang = Number(longs);
      const size = 10;
      setLoaded(false);
      // let address = await getAddress(lat, lang);
      if (lat && lang) {
        await getLocationData(lat, lang, address);
        await getCoordinates(lat, lang, size);
        setLat(lat);
        setLong(lang);
        setLatMap(Number(lat));
        setLongMap(Number(lang));
        setZoom(11);
        setLocation(lat, lang);
      }
      setLoaded(true);
      setSLoaded(true);
    } catch (error) {
      console.log(error);
      getCurrentLocation();
    }
  };

  const onDragFun = (e) => {
    const lat = Number(e.latLng.lat());
    const lang = Number(e.latLng.lng());
    const size = 10;
    onPlaceChangedNew(lat, lang);
    setLatMap(lat);
    setLongMap(long);
  };
  const showDetails = (e) => {
    getWorkshopsJourneyCategory(e.Id);
    getWorkshopAmenities(e.Id);
    setWorkShop(e);
    daysArray(e);
    setHide(true);
  };

  const daysArray = (e) => {
    let array = [
      { from: e.MondayFrom, to: e.MondayTo, day: "Monday" },
      { from: e.TuesdayFrom, to: e.TuesdayTo, day: "Tuesday" },
      { from: e.WednesdayFrom, to: e.WednesdayTo, day: "Wednesday" },
      { from: e.ThursdayFrom, to: e.ThursdayTo, day: "Thursday" },
      { from: e.FridayFrom, to: e.FridayTo, day: "Friday" },
      { from: e.SaturdayFrom, to: e.SaturdayTo, day: "Saturday" },
      { from: e.SundayFrom, to: e.SundayTo, day: "Sunday" },
    ];
    setDays(array);
  };

  const handleCenterChanged = () => {
    if (map && coordinatesData?.length > 0) {
      const newCenter = map.getCenter();
      const latCurrent = Number(newCenter.lat());
      const langCurrent = Number(newCenter.lng());
      // if (lat != latCurrent && latCurrent != 0) {
      setLatTemp(Number(latCurrent));
      // }
      // if (long != langCurrent && langCurrent != 0) {
      setLongTemp(Number(langCurrent));
      // }
      setLatMap(Number(latCurrent));
      setLongMap(Number(langCurrent));
      // setZoom(11);

      // onPlaceChangedNew(lat, lang);
    }
  };

  const onSearchClick = () => {
    if (map) {
      const newCenter = map.getCenter();
      const latCurrent = Number(newCenter.lat());
      const langCurrent = Number(newCenter.lng());
      getCoordinates(latCurrent, langCurrent, 10);
      setLatMap(latCurrent);
      setLongMap(langCurrent);
      setCheckCenter(false);
    }
  };

  const handleChange = (address) => {
    setLocationText(address);
  };

  const handleSelect = (address) => {
    setLocationText(address);
    setActiveLocationChange(false);
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setLat(latLng.lat);
        setLong(latLng.lng);
        onPlaceChangedNew(latLng.lat, latLng.lng);
      })
      .catch((error) => console.error("Error", error));
  };

  const handleWorkshopCenterChange = () => {
    setLatMap(coordinatesData[0].Latitude);
    setLongMap(coordinatesData[0].Longitude);
    setCheckCenter(false);
  };

  const searchByName = (query, array) => {
    setSearch(query);
    if (query == "") {
      setSearchList([]);
      return;
    }
    const searchResults = array.filter((item) => {
      const itemName = item.Name.toLowerCase();
      return itemName.includes(query.toLowerCase());
    });
    setSearchList(searchResults);
  };

  const handleCreateJob = (data) => {
    
    setLoader(true);
    setCartStage(2);
    sessionStorage.setItem("isWorkshopCollection", "true");
    const route = `/services/${
      globalData.locationData?.data?.EmirateAreaSlug || "dubai"
    }/oil-change/${carNameParam}/${data.Slug}`;
    getWorkshopsProductCategory(data.Id, globalData.carData?.modelId);
    router.push(route);
  };

  const onBlur = (event) => {
    // setHide(false)
  };
  const dubaiLatLang = {
    north: 26.055464179,
    south: 22.4969475367,
    west: 51.5795186705,
    east: 56.3968473651,
  };

  const defaultCenter = { lat: 25.2048, lng: 55.2708 }; // Default center point in Dubai
  const libraries = ["places"]; // Define libraries as a constant variable

  const stylesArr = [
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [{ saturation: 36 }, { color: "#ffffff" }, { lightness: 10 }],
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 60 }],
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [{ color: "#ffffff" }, { lightness: 20 }],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{ color: "#ffffff" }, { lightness: 17 }, { weight: 1.2 }],
    },
  ];

  let boxHeight = 0;

  if (typeof document !== "undefined") {
    boxHeight = document.querySelector(".search-box")?.clientHeight / 2;
  }

  const calculateGoogleRating = (rate) => {
    return rate * 20;
  };

  return (
    <section className={handleClasses("map-view-block")}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 col-lg-5">
            <div className={handleClasses("header-bar-ws")}>
              <div className={handleClasses("ws-sr-loca")}>
                <label>Car Location</label>
                <div className={handleClasses("ws-sr-locain")}>
                  <i
                    onClick={getCurrentLocation}
                    style={{ cursor: "pointer" }}
                    className={`fa-solid fa-location-crosshairs ${handleClasses(
                      "fa-location-crosshairs"
                    )}`}
                  />
                  {/* {sLoaded && 
                  <Autocomplete
                      onLoad={onLoading}
                      onPlaceChanged={onPlaceChanged}
                      types={"geocode"}
                      restrictions={{ country: ["AE"] }}
                    > */}
                  {/* <input
                    type="text"
                    className="form-control"
                    value={locationText}
                    ref={ref}
                    onChange={(e) => setLocationText(e.target.value)}
                  /> */}
                  {autocompleted ? (
                    <Autocomplete
                      onLoad={onLoading}
                      onPlaceChanged={onPlaceChanged}
                      types={"geocode"}
                      restrictions={{ country: ["AE"] }}
                    >
                      <input
                        type="text"
                        placeholder="Search Location"
                        className="form-control"
                        ref={ref}
                        value={locationText}
                        onChange={(e) => setLocationText(e.target.value)}
                      />
                    </Autocomplete>
                  ) : (
                    <input
                      type="text"
                      placeholder="Search Location"
                      className="form-control"
                      ref={ref}
                      value={locationText}
                      onChange={(e) => setLocationText(e.target.value)}
                    />
                  )}
                </div>
              </div>
              <div className={handleClasses("ob-ws-sr")}>
                <div className={handleClasses("nr-wshp")}>
                  <h3>Nearest OB Workshop</h3>
                  <span>
                    Found {search ? searchList.length : coordinatesData?.length}{" "}
                    results
                  </span>
                </div>
                <div className={handleClasses("searchh-nr-wrh")}>
                  <i
                    className={`fa-solid fa-magnifying-glass ${handleClasses(
                      "fa-magnifying-glass"
                    )}`}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name"
                    onChange={(e) =>
                      searchByName(e.target.value, coordinatesData)
                    }
                  />
                </div>
              </div>
            </div>
            <div className={handleClasses("lsitingob-outer")}>
              <div className={handleClasses("listing-inner-ob")}>
                <ul>
                  {search && searchList
                    ? searchList.map((item) => {
                        return (
                          <li>
                            <div className={handleClasses("ls-img-blc")}>
                              <img
                                className={handleClasses("img-fluid")}
                                src="assets/header/slider.webp"
                                alt="slider"
                              />
                            </div>
                            <div className={handleClasses("wrs-rg")}>
                              <div className={handleClasses("wf-inf")}>
                                <h2>{item.Name}</h2>
                                <label>{item.AreaName}</label>
                                {item.Offer ? (
                                  <label
                                    className={handleClasses("pl-offer-label")}
                                    // title="Offer Available"
                                    style={{ color: "#ff3201 !important"}}
                                  >
                                    <img src="/assets/workshop/party-icon.webp" />{" "}
                                    Offer Available
                                  </label>
                                ) : null}
                              </div>
                              <div className={handleClasses("wf-lc")}>
                                <span>
                                  <i className="fa-solid fa-location-dot" />
                                  Distance :{" "}
                                  {parseFloat(item.Distance).toFixed(2)} KM
                                </span>
                                <div className={handleClasses("star-rating")}>
                                  <div className={handleClasses("back-stars")}>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>

                                    <div
                                      className={handleClasses("front-stars")}
                                      style={{
                                        width: `${calculateGoogleRating(
                                          item.GoogleRating
                                        )}%`,
                                      }}
                                    >
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      ></i>
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      ></i>
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      ></i>
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      ></i>
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={handleClasses("wf-act")}>
                                <button
                                  onClick={() => handleCreateJob(item)}
                                  className={`btn ${handleClasses("crt-job")}`}
                                >
                                  Create Job
                                </button>
                                <button
                                  onClick={() => handleVisitStoreFront(item)}
                                  className={`btn ${handleClasses("vs-frnt")}`}
                                >
                                  Visit Storefront
                                </button>
                              </div>
                            </div>
                          </li>
                        );
                      })
                    : null}
                  {search && searchList.length == 0 ? (
                    <li className="text-center">No Data Found</li>
                  ) : null}
                  {coordinatesData &&
                  coordinatesData.length &&
                  !search &&
                  !skeletonLoading
                    ? coordinatesData.map((item) => (
                        <li>
                          <div className={handleClasses("ls-img-blc")}>
                            <img
                              className={handleClasses("img-fluid")}
                              src={item.CoverImageUrl}
                              alt="CoverImage"
                            />
                          </div>
                          <div className={handleClasses("wrs-rg")}>
                            <div className={handleClasses("wf-inf")}>
                              <h2>{item.Name}</h2>
                              <label>{item.AreaName}</label>
                              {item.Offer ? (
                                <label
                                  className={handleClasses("pl-offer-label")}
                                  // title="Offer Available"
                                  style={{ color: "#ff3201 !important"}}
                                >
                                  <img src="/assets/workshop/party-icon.webp" />{" "}
                                  Offer Available
                                </label>
                              ) : null}
                            </div>
                            <div className={handleClasses("wf-lc")}>
                              <span>
                                <i className="fa-solid fa-location-dot" />
                                Distance :{" "}
                                {parseFloat(item.Distance).toFixed(2)} KM
                              </span>
                              <div className={handleClasses("star-rating")}>
                                <div className={handleClasses("back-stars")}>
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  ></i>
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  ></i>
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  ></i>
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  ></i>
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  ></i>

                                  <div
                                    className={handleClasses("front-stars")}
                                    style={{
                                      width: `${calculateGoogleRating(
                                        item.GoogleRating
                                      )}%`,
                                    }}
                                  >
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                    <i
                                      className="fa fa-star"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={handleClasses("wf-act")}>
                              <button
                                onClick={() => handleCreateJob(item)}
                                className={`btn ${handleClasses("crt-job")}`}
                              >
                                Create Job
                              </button>
                              <button
                                onClick={() => handleVisitStoreFront(item)}
                                className={`btn ${handleClasses("vs-frnt")}`}
                              >
                                Visit Storefront
                              </button>
                            </div>
                          </div>
                        </li>
                      ))
                    : !search
                    ? [null, null, null].map((item) => {
                        return (
                          <div className={handleClasses("ls-img-blc")}>
                            <Skeleton style={{ width: "100%" }} height={150} />
                          </div>
                        );
                      })
                    : null}
                </ul>
              </div>
            </div>
          </div>
          <div
            ref={divRef}
            className={`col-md-6 col-lg-7 position-relative ${handleClasses(
              "map-right-element"
            )}`}
          >{
            coordinatesData.length? <MapComponent coordinatesData={coordinatesData} height={isMobile?"350px":"611px"}/>:null
          }
            
          </div>
          <div>
            {hide && (
              <Modal show={hide} onHide={() => setHide(false)}>
                <Modal.Body className="position-relative p-0">
                  <WorkshopModal
                    workShop={workShop}
                    amenitiesData={amenitiesData}
                    days={days}
                    workshopJourneyCategoryData={workshopJourneyCategoryData}
                    setHide={setHide}
                  />
                </Modal.Body>
              </Modal>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setLocation: (lat, lang) => {
      dispatch(setLocation(lat, lang));
    },
    fetchDefaultWorkshop: () => {
      dispatch(fetchDefaultWorkshop());
    },
    getModel: (ID) => {
      dispatch(getModel(ID));
    },
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
    setCartStage: (value) => {
      dispatch(setCartStage(value));
    },
    getWorkshopsProductCategory: (id, mId) => {
      dispatch(getWorkshopsProductCategory(id, mId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapView);
